<div class="invoice-progress-state" [ngClass]="stateColorClass">
  <div class="invoice-progress-state-startpoint">
    <div class="invoice-progress-state-progress" [style.background-size]="progressBackgroundSize"></div>

    <ng-content select="[startPoint]"></ng-content>

    <span *ngIf="startLocation" class="invoice-progress-state-location">{{ startLocation }}</span>

    <ng-container *ngIf="isStartPosition"
                  [ngTemplateOutlet]="informer">
    </ng-container>
  </div>

  <div class="invoice-progress-state-endpoint" [class.gray]="!isCompletedProgress">
    <ng-container *ngIf="isEndTopPosition"
                  [ngTemplateOutlet]="informer">
    </ng-container>

    <ng-content select="[endPoint]"></ng-content>

    <span *ngIf="endLocation" class="invoice-progress-state-location">{{ endLocation }}</span>

    <ng-container *ngIf="isEndBottomPosition"
                  [ngTemplateOutlet]="informer">
    </ng-container>

    <ng-content select="[processInformer]"></ng-content>

    <span *ngIf="showNote && getNote" class="invoice-progress-state-endpoint-note">
      {{ getNote }}
    </span>
  </div>
</div>

<ng-template #informer>
  <app-progress-state-informer
    [icon]="informerIcon"
    [color]="stateColor"
    [informerDate]="informerDate"
    [text]="informerText">
  </app-progress-state-informer>
</ng-template>
